/** WGS84 ↔ LV95 (EPSG:2056) via proj4. PROTOCOLS.md §7.3. */
import proj4 from 'proj4';

proj4.defs(
  'EPSG:2056',
  '+proj=somerc +lat_0=46.9524055555556 +lon_0=7.43958333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs',
);

const toLv95 = proj4('EPSG:4326', 'EPSG:2056');

export function wgs84ToLv95(lat: number, lon: number): { e: number; n: number } {
  const [e, n] = toLv95.forward([lon, lat]) as [number, number];
  return { e, n };
}

export function lv95ToWgs84(e: number, n: number): { lat: number; lon: number } {
  const [lon, lat] = toLv95.inverse([e, n]) as [number, number];
  return { lat, lon };
}

/** Rough LV95 extent of Switzerland (+ margin): swisstopo DEM coverage. */
export function insideSwitzerland(e: number, n: number): boolean {
  return e > 2_480_000 && e < 2_840_000 && n > 1_070_000 && n < 1_300_000;
}
